var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlStatusGap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gap-status-gap__Property 1=Gap status gap",
    className: "gap-status-gap__Property gap-status-gap__1=Gap gap-status-gap__status gap-status-gap__gap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gap-status-gap__\\xE2\\x9C\\xB3\\xEF\\xB8\\x8F start icon",
    className: "gap-status-gap__\\xE2\\x9C\\xB3\\xEF\\xB8\\x8F gap-status-gap__start gap-status-gap__icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "gap-status-gap__Ellipse 110",
    cx: 8,
    cy: 8,
    r: 5,
    fill: "#FA5252",
    className: "gap-status-gap__Ellipse gap-status-gap__110"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlStatusGap);
export default __webpack_public_path__ + "static/media/control_status_gap.0fe9bf064163c8b7b7c26969373f11d6.svg";
export { ForwardRef as ReactComponent };